module.exports = __webpack_public_path__ + "static/media/group--co-occupational-safety--dark.8193eb9e.svg";